import "./main.scss";
import "./blocks";

console.log("Plugin version 0.0.1 (8a38882)");
